const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label for="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							onchange="{~D:Record.Macro.DataRequestFunction~}"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="DATE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-calendar fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar-clock fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<input class="input"
					{~D:Record.Macro.ControlAttr~}
					id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					{~D:Record.Macro.HTMLName~}
					readonly aria-readonly="true"
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-calendar fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<div
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<div
								id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="DATE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
